import React from 'react';
import './services.css';
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5> What I Offer</h5>
      <h2>Services</h2>

      <div className='container services__container'>
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Web design: A shown expertise in designing web pages using HTML, CSS, and JavaScript which highlights user-friendly interfaces that are visually appealing and easy to navigate.
              </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>E-commerce development
              </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Content management system (CMS) development
              </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Search engine optimization (SEO)
              </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Website maintenance and support
              </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Frontend development
              </p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services